export default __webpack_public_path__ + "static/media/business-report.0bbef881.png";